import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { Image, Wrapper } from '@farewill/ui'
import { BREAKPOINT } from '@farewill/ui/tokens'
import { CLOUDINARY_ROOT_PATH } from '@farewill/ui/components/Image/constants'

import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions'
import BreakpointSwitch from 'components/BreakpointSwitch'

/**
 * Line breaks added in Contentful's rich text editor are stored as `\n`
 * characters within a paragraph's text, which HTML collapses into a single
 * space. `pre-line` preserves them without changing the other whitespace.
 */
const StyledWrapper = styled(Wrapper)`
  dd p {
    white-space: pre-line;
  }
`

const FAQ = ({
  questions,
  imagePath,
}: {
  questions: GatsbyTypes.ContentfulFaqSection['questions']
  imagePath: string
}): ReactElement => (
  <StyledWrapper margin={0} marginFromL={['XXL', 0, 'XXL']}>
    <FrequentlyAskedQuestions
      title="Frequently asked questions"
      customImageComponent={
        <BreakpointSwitch
          breakAt={BREAKPOINT.M}
          aboveComponent={
            <Image
              path={imagePath}
              formatPath={({ path, ext, width }) =>
                `${CLOUDINARY_ROOT_PATH}/c_fill,f_auto,q_auto,h_${width},w_${width}/r_max/${path}.${ext}`
              }
              ext="jpg"
              width={350}
            />
          }
        />
      }
      questions={questions}
      customAmount={4}
    />
  </StyledWrapper>
)

export default FAQ
